import angular from 'angular';
import { fetchBanners } from 'app/actions/banners.actions';
import { fetchWidgets } from 'app/actions/widgets.actions';
import './management/cms-management-component';
import * as api from 'app/resources/widgets.api';
import homeTemplate from './home.html';

const mapStateToThis = (state) => {
  const { locale } = state.session;
  const { homePageLogos = [] } = state.config;
  const { items: widgets, isMaintenance: widgetMaintenance } = state.widgets;
  const { items: banners, interval } = state.banners;

  return {
    locale,
    widgets,
    widgetMaintenance,
    banners,
    interval,
    homePageLogos,
  };
};

const mapDispatchToThis = {
  fetchBanners,
  fetchWidgets,
};

// eslint-disable-next-line no-undef
@Inject('Responsive', '$ngRedux', '$state', 'Notifications', 'gettextCatalog')
class HomeController {
  constructor() {
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);

    this.fetchBanners(true);
    this.fetchWidgets(true);
  }

  $onInit() {
    if (this.$state.params.registrationConfirm) {
      this.Notifications.alertSuccess(this.gettextCatalog.getString('Account registration completed successfully'));
    }
    this.logos = this.homePageLogos.filter((logo) => logo.enabled && !logo.loggedIn);
  }

  $onDestroy() {
    this.unsubscribe();
  }

  onDownloadWidgetAttachment(widget) {
    api.downloadAttachment(widget);
  }
}

class HomeComponent {
  constructor() {
    this.controller = HomeController;
    this.template = homeTemplate;
    this.bindings = {
      model: '<',
      api: '<',
      forgotUsername: '<',
    };
    return this;
  }
}

angular
  .module('home', ['cms-management'])
  .component('home', new HomeComponent())
  .config([
    '$stateProvider',
    function configure($stateProvider) {
      $stateProvider.state('home-view', {
        parent: 'arw',
        url: '/home',
        template: `<home
                   model="appCtrl.appFactory.model"
                   api="$resolve.api"
                   forgot-username="appCtrl.appFactory.deps.checkAccess(appCtrl.appFactory.model, 'auth.forgotUsername')"
                ></home>`,
        params: {
          registrationConfirm: false,
          skipDirtyForms: false,
        },
        withoutPerms: true,
        resolve: {
          api: [
            'appFactory',
            'appApi',
            '$stateParams',
            'gettextCatalog',
            (appFactory) =>
              appFactory
                .dispatch('app.getWidgets', true)
                .run(true)
                .then(() => ({
                  downloadWidgetAttachment: appFactory.dispatch('app.downloadWidgetAttachment', true),
                  loginForm: {
                    config: appFactory.deps.config,
                    login: appFactory.dispatch('auth.login', true),
                    loadJurisdictionData: appFactory.dispatch('app.loadJurisdictionData', true),
                    initNgServices: appFactory.initNgServices,
                  },
                }))
                .catch((err) => console.error(err)),
          ],
        },
      });
    },
  ]);



// WEBPACK FOOTER //
// ./src/modules/app/components/home/home-component.js